const APS_URL = "https://dev.insightwin.com/backend/aps";

export default APS_URL;
